import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import "./Gray_btn.css";

const Gray_btn = (props) => {
  return (
    <button className="Gray_btn" onClick={props?.onClick} type="button">
      {props?.lefticon && (
        <div className="icon_holder">
          <FontAwesomeIcon icon={props?.lefticon} className="lefticon" />
        </div>
      )}
      <p className="btn_text">{props?.btn_name}</p>
    </button>
  );
};

export default Gray_btn;
